// Mock data for the CRM → Packages tab.
// Shape mirrors real package-order data (see admin/components/pakageSetComp/mockData.js)
// so this can later be swapped for a live endpoint without changing the UI.

const initials = (name) =>
   name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]).join('').toUpperCase();

const buildMoney = (packagePrice) => {
   const platformFee = 5.0;
   const customerCharged = parseFloat((packagePrice + platformFee).toFixed(2));
   const commission = parseFloat((packagePrice * 0.08).toFixed(2));
   const stripeFee = parseFloat((customerCharged * 0.029 + 1.0).toFixed(2));
   const washtaNet = parseFloat((commission + platformFee - stripeFee).toFixed(2));
   const providerPayout = parseFloat((packagePrice - commission).toFixed(2));
   return { packagePrice, platformFee, customerCharged, commission, stripeFee, washtaNet, providerPayout };
};

const raw = [
   {
      id: 'PKG-CRM-10231', customer: 'Sarah Al Mansoori', email: 'sarah.almansoori@gmail.com',
      vehicle: 'Nissan Patrol', plate: 'DXB A 45231', carType: 'SUV',
      location: 'Al Muneera', provider: 'GeoWash', plan: '12 washes / mo', planTier: 12, frequency: '3x/week',
      washesUsed: 9, purchasedOn: '2026-07-03', expiresOn: '2026-08-03', packagePrice: 276, status: 'Active', autoRenew: true,
      deliveries: [
         { date: '03 Jul', status: 'Completed', note: 'GeoWash · 08:12' },
         { date: '06 Jul', status: 'Completed', note: 'GeoWash · 08:20' },
         { date: '08 Jul', status: 'Completed', note: 'GeoWash · 08:05' },
         { date: '13 Jul', status: 'Completed', note: 'GeoWash · 08:19' },
         { date: '15 Jul', status: 'Completed', note: 'GeoWash · 08:22' },
         { date: '20 Jul', status: 'Completed', note: 'GeoWash · 08:14' },
         { date: '22 Jul', status: 'Completed', note: 'GeoWash · 08:30' },
         { date: '27 Jul', status: 'Completed', note: 'GeoWash · 08:11' },
         { date: '29 Jul', status: 'Completed', note: 'GeoWash · 08:09' },
         { date: '01 Aug', status: 'Due today', note: 'pending' },
         { date: '03 Aug', status: 'Scheduled', note: '—' },
      ],
   },
   {
      id: 'PKG-CRM-10198', customer: 'Ahmed Haddad', email: 'a.haddad@outlook.com',
      vehicle: 'Toyota Camry', plate: 'AUH 3 91120', carType: 'Sedan',
      location: 'Gate Towers', provider: 'GeoWash', plan: '8 washes / mo', planTier: 8, frequency: '2x/week',
      washesUsed: 8, purchasedOn: '2026-06-28', expiresOn: '2026-07-28', packagePrice: 144, status: 'Expiring Soon', autoRenew: false,
      deliveries: [
         { date: '28 Jun', status: 'Completed', note: 'GeoWash · 09:14' },
         { date: '01 Jul', status: 'Completed', note: 'GeoWash · 09:05' },
         { date: '05 Jul', status: 'Completed', note: 'GeoWash · 08:42' },
         { date: '08 Jul', status: 'Completed', note: 'GeoWash · 08:31' },
         { date: '12 Jul', status: 'Completed', note: 'GeoWash · 08:50' },
         { date: '15 Jul', status: 'Completed', note: 'GeoWash · 08:44' },
         { date: '19 Jul', status: 'Completed', note: 'GeoWash · 08:36' },
         { date: '22 Jul', status: 'Completed', note: 'GeoWash · 08:40' },
      ],
   },
   {
      id: 'PKG-CRM-10166', customer: 'Mariam Sultan', email: 'mariam.sultan@yahoo.com',
      vehicle: 'Lexus RX', plate: 'SHJ 1 22087', carType: 'SUV',
      location: 'Al Muneera', provider: 'Clean Car ME', plan: '8 washes / mo', planTier: 8, frequency: '2x/week',
      washesUsed: 3, purchasedOn: '2026-06-28', expiresOn: '2026-07-28', packagePrice: 192, status: 'Active', autoRenew: true,
      deliveries: [
         { date: '30 Jun', status: 'Completed', note: 'Clean Car ME · 09:12' },
         { date: '03 Jul', status: 'Missed', note: 'no action by 23:59' },
         { date: '07 Jul', status: 'Completed', note: 'Clean Car ME · 09:00' },
         { date: '10 Jul', status: 'Missed', note: 'no action by 23:59' },
         { date: '14 Jul', status: 'Completed', note: 'Clean Car ME · 09:08' },
         { date: '21 Jul', status: 'Due today', note: 'pending' },
         { date: '24 Jul', status: 'Scheduled', note: '—' },
      ],
   },
   {
      id: 'PKG-CRM-10102', customer: 'Rafael Fernandes', email: 'rafael.f@gmail.com',
      vehicle: 'Honda Accord', plate: 'AUH 9 30044', carType: 'Sedan',
      location: 'ADNOC HQ — Office', provider: 'GeoWash', plan: '12 washes / mo', planTier: 12, frequency: '3x/week',
      washesUsed: 13, purchasedOn: '2026-06-20', expiresOn: '2026-07-20', packagePrice: 216, status: 'Expired', autoRenew: false, renewed: true,
      deliveries: Array.from({ length: 13 }).map((_, i) => ({
         date: `${20 + i} Jun`, status: 'Completed', note: 'GeoWash',
      })),
   },
   {
      id: 'PKG-CRM-10087', customer: 'Fatima Al Zaabi', email: 'fatima.alzaabi@gmail.com',
      vehicle: 'Range Rover Sport', plate: 'DXB C 77219', carType: 'SUV',
      location: 'Marina Heights', provider: 'GeoWash', plan: '4 washes / mo', planTier: 4, frequency: '1x/week',
      washesUsed: 4, purchasedOn: '2026-06-15', expiresOn: '2026-07-15', packagePrice: 96, status: 'Expired', autoRenew: false, renewed: false,
      deliveries: [
         { date: '15 Jun', status: 'Completed', note: 'GeoWash · 08:00' },
         { date: '22 Jun', status: 'Completed', note: 'GeoWash · 08:10' },
         { date: '29 Jun', status: 'Completed', note: 'GeoWash · 08:05' },
         { date: '06 Jul', status: 'Completed', note: 'GeoWash · 08:15' },
      ],
   },
   {
      id: 'PKG-CRM-10305', customer: 'Omar Yousef', email: 'omar.yousef@hotmail.com',
      vehicle: 'BMW X5', plate: 'DXB M 10983', carType: 'SUV',
      location: 'Hydra Avenue', provider: 'GeoWash', plan: '8 washes / mo', planTier: 8, frequency: '2x/week',
      washesUsed: 5, purchasedOn: '2026-07-10', expiresOn: '2026-08-10', packagePrice: 184, status: 'Active', autoRenew: true,
      deliveries: [
         { date: '10 Jul', status: 'Completed', note: 'GeoWash · 08:20' },
         { date: '13 Jul', status: 'Completed', note: 'GeoWash · 08:12' },
         { date: '17 Jul', status: 'Completed', note: 'GeoWash · 08:19' },
         { date: '20 Jul', status: 'Completed', note: 'GeoWash · 08:08' },
         { date: '24 Jul', status: 'Completed', note: 'GeoWash · 08:22' },
         { date: '27 Jul', status: 'Due today', note: 'pending' },
         { date: '31 Jul', status: 'Scheduled', note: '—' },
         { date: '03 Aug', status: 'Scheduled', note: '—' },
      ],
   },
   {
      id: 'PKG-CRM-10412', customer: 'Layla Karam', email: 'layla.karam@gmail.com',
      vehicle: 'Kia Sportage', plate: 'SHJ 4 65510', carType: 'SUV',
      location: 'Sun Tower', provider: 'GeoWash', plan: '4 washes / mo', planTier: 4, frequency: '1x/week',
      washesUsed: 1, purchasedOn: '2026-07-18', expiresOn: '2026-08-18', packagePrice: 96, status: 'Active', autoRenew: true,
      deliveries: [
         { date: '18 Jul', status: 'Completed', note: 'GeoWash · 08:04' },
         { date: '25 Jul', status: 'Due today', note: 'pending' },
         { date: '01 Aug', status: 'Scheduled', note: '—' },
         { date: '08 Aug', status: 'Scheduled', note: '—' },
      ],
   },
   {
      id: 'PKG-CRM-10059', customer: 'Khalid Bin Rashid', email: 'khalid.br@gmail.com',
      vehicle: 'Mercedes GLE', plate: 'AUH 7 40021', carType: 'SUV',
      location: 'Al Zeina', provider: 'GeoWash', plan: '12 washes / mo', planTier: 12, frequency: '3x/week',
      washesUsed: 12, purchasedOn: '2026-06-10', expiresOn: '2026-07-10', packagePrice: 276, status: 'Expired', autoRenew: true, renewed: true,
      deliveries: Array.from({ length: 12 }).map((_, i) => ({ date: `${10 + i} Jun`, status: 'Completed', note: 'GeoWash' })),
   },
   {
      id: 'PKG-CRM-10450', customer: 'Noura Al Suwaidi', email: 'noura.alsuwaidi@gmail.com',
      vehicle: 'Toyota Land Cruiser', plate: 'DXB B 88342', carType: 'SUV',
      location: 'Julphar Residence', provider: 'GeoWash', plan: '8 washes / mo', planTier: 8, frequency: '2x/week',
      washesUsed: 8, purchasedOn: '2026-07-01', expiresOn: '2026-07-31', packagePrice: 184, status: 'Expiring Soon', autoRenew: false,
      deliveries: [
         { date: '01 Jul', status: 'Completed', note: 'GeoWash · 08:00' },
         { date: '04 Jul', status: 'Completed', note: 'GeoWash · 08:05' },
         { date: '08 Jul', status: 'Completed', note: 'GeoWash · 08:10' },
         { date: '11 Jul', status: 'Completed', note: 'GeoWash · 08:15' },
         { date: '15 Jul', status: 'Completed', note: 'GeoWash · 08:20' },
         { date: '18 Jul', status: 'Completed', note: 'GeoWash · 08:25' },
         { date: '22 Jul', status: 'Completed', note: 'GeoWash · 08:30' },
         { date: '25 Jul', status: 'Completed', note: 'GeoWash · 08:35' },
      ],
   },
   {
      id: 'PKG-CRM-10520', customer: 'Youssef Al Amin', email: 'youssef.alamin@gmail.com',
      vehicle: 'Ford Explorer', plate: 'DXB Z 11209', carType: 'SUV',
      location: 'Masdar City Res.', provider: 'Clean Car ME', plan: '12 washes / mo', planTier: 12, frequency: '3x/week',
      washesUsed: 2, purchasedOn: '2026-07-19', expiresOn: '2026-08-19', packagePrice: 300, status: 'Active', autoRenew: true,
      deliveries: [
         { date: '19 Jul', status: 'Completed', note: 'Clean Car ME · 09:00' },
         { date: '21 Jul', status: 'Completed', note: 'Clean Car ME · 09:10' },
         { date: '24 Jul', status: 'Due today', note: 'pending' },
         { date: '26 Jul', status: 'Scheduled', note: '—' },
      ],
   },
   {
      id: 'PKG-CRM-10077', customer: 'Aisha Al Blooshi', email: 'aisha.alblooshi@gmail.com',
      vehicle: 'Hyundai Tucson', plate: 'SHJ 2 50098', carType: 'SUV',
      location: 'Etihad Towers Res.', provider: 'GeoWash', plan: '4 washes / mo', planTier: 4, frequency: '1x/week',
      washesUsed: 2, purchasedOn: '2026-07-05', expiresOn: '2026-08-05', packagePrice: 96, status: 'Cancelled', autoRenew: false,
      deliveries: [
         { date: '05 Jul', status: 'Completed', note: 'GeoWash · 08:00' },
         { date: '12 Jul', status: 'Completed', note: 'GeoWash · 08:05' },
         { date: '19 Jul', status: 'Cancelled', note: 'Customer cancelled subscription' },
      ],
   },
   {
      id: 'PKG-CRM-10389', customer: 'Hamdan Al Nuaimi', email: 'hamdan.n@gmail.com',
      vehicle: 'Nissan Altima', plate: 'AUH 5 60312', carType: 'Sedan',
      location: 'Shams 1', provider: 'GeoWash', plan: '8 washes / mo', planTier: 8, frequency: '2x/week',
      washesUsed: 6, purchasedOn: '2026-07-08', expiresOn: '2026-08-08', packagePrice: 144, status: 'Active', autoRenew: true,
      deliveries: [
         { date: '08 Jul', status: 'Completed', note: 'GeoWash · 08:10' },
         { date: '11 Jul', status: 'Completed', note: 'GeoWash · 08:12' },
         { date: '15 Jul', status: 'Completed', note: 'GeoWash · 08:14' },
         { date: '18 Jul', status: 'Completed', note: 'GeoWash · 08:16' },
         { date: '22 Jul', status: 'Completed', note: 'GeoWash · 08:18' },
         { date: '25 Jul', status: 'Completed', note: 'GeoWash · 08:20' },
         { date: '29 Jul', status: 'Due today', note: 'pending' },
         { date: '01 Aug', status: 'Scheduled', note: '—' },
      ],
   },
   {
      id: 'PKG-CRM-10611', customer: 'Reem Al Marzooqi', email: 'reem.almarzooqi@gmail.com',
      vehicle: 'Chevrolet Tahoe', plate: 'DXB D 90211', carType: 'SUV',
      location: 'Gate Towers', provider: 'GeoWash', plan: '12 washes / mo', planTier: 12, frequency: '3x/week',
      washesUsed: 1, purchasedOn: '2026-07-21', expiresOn: '2026-08-21', packagePrice: 276, status: 'Active', autoRenew: true,
      deliveries: [
         { date: '21 Jul', status: 'Completed', note: 'GeoWash · 08:30' },
         { date: '23 Jul', status: 'Due today', note: 'pending' },
         { date: '25 Jul', status: 'Scheduled', note: '—' },
      ],
   },
   {
      id: 'PKG-CRM-10029', customer: 'Salem Al Katheeri', email: 'salem.alkatheeri@gmail.com',
      vehicle: 'Toyota Prado', plate: 'AUH 1 15590', carType: 'SUV',
      location: 'ADNOC HQ — Office', provider: 'GeoWash', plan: '4 washes / mo', planTier: 4, frequency: '1x/week',
      washesUsed: 4, purchasedOn: '2026-06-05', expiresOn: '2026-07-05', packagePrice: 96, status: 'Expired', autoRenew: false, renewed: false,
      deliveries: [
         { date: '05 Jun', status: 'Completed', note: 'GeoWash · 08:00' },
         { date: '12 Jun', status: 'Completed', note: 'GeoWash · 08:05' },
         { date: '19 Jun', status: 'Completed', note: 'GeoWash · 08:10' },
         { date: '26 Jun', status: 'Completed', note: 'GeoWash · 08:15' },
      ],
   },
   {
      id: 'PKG-CRM-10555', customer: 'Mona Al Hashimi', email: 'mona.alhashimi@gmail.com',
      vehicle: 'Audi Q7', plate: 'DXB F 33871', carType: 'SUV',
      location: 'Al Muneera', provider: 'Clean Car ME', plan: '8 washes / mo', planTier: 8, frequency: '2x/week',
      washesUsed: 7, purchasedOn: '2026-07-02', expiresOn: '2026-08-01', packagePrice: 192, status: 'Expiring Soon', autoRenew: true,
      deliveries: [
         { date: '02 Jul', status: 'Completed', note: 'Clean Car ME · 09:00' },
         { date: '05 Jul', status: 'Completed', note: 'Clean Car ME · 09:05' },
         { date: '09 Jul', status: 'Completed', note: 'Clean Car ME · 09:10' },
         { date: '12 Jul', status: 'Completed', note: 'Clean Car ME · 09:15' },
         { date: '16 Jul', status: 'Completed', note: 'Clean Car ME · 09:20' },
         { date: '19 Jul', status: 'Completed', note: 'Clean Car ME · 09:25' },
         { date: '23 Jul', status: 'Completed', note: 'Clean Car ME · 09:30' },
         { date: '26 Jul', status: 'Due today', note: 'pending' },
      ],
   },
];

export const CRM_PACKAGES = raw.map((p) => ({
   ...p,
   initials: initials(p.customer),
   money: buildMoney(p.packagePrice),
}));

export const CRM_PACKAGE_LOCATIONS = Array.from(new Set(CRM_PACKAGES.map((p) => p.location))).sort();
export const CRM_PACKAGE_PROVIDERS = Array.from(new Set(CRM_PACKAGES.map((p) => p.provider))).sort();
export const CRM_PACKAGE_PLANS = ['4 washes / mo', '8 washes / mo', '12 washes / mo'];
export const CRM_PACKAGE_STATUSES = ['Active', 'Expiring Soon', 'Expired', 'Cancelled'];
